import { React, useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { marked } from "marked";
import Quill from "quill";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import { convertMarkdownToHtml, styles } from "../utils/convertMarkdownToHTML";
import DOMPurify from "dompurify";

import PDFHighlight from "./PDFHighlight";
import WordCharCounter from "./WordCharCounter";
import UserMessageEditor from "./UserMessageEditor";
import BotMessageEditor from "./BotMessageEditor";


const fonts = [
  "Arial", "Comic Sans MS", "Courier New", "Georgia", "Helvetica",
  "Lucida Sans", "Times New Roman", "Verdana", "Tahoma",
  "Trebuchet MS", "Impact", "Monospace"
];

const fontClassNames = fonts.map(font => font.toLowerCase().replace(/\s+/g, "-"));


const CustomToolbar = () => (
  <div id="toolbar-container" className="p-2">
    <span className="ql-formats">
      <select className="ql-font text-white">
        {fonts.map(font => (
          <option key={font} value={font.toLowerCase()} className="text-white">{font}</option>
        ))}
      </select>
      <select className="ql-size text-white"></select>
    </span>
    <span className="ql-formats">
      <button className="ql-bold"></button>
      <button className="ql-italic"></button>
      <button className="ql-underline"></button>
      {/* <button className="ql-strike"></button> */}
    </span>
    <span className="ql-formats">
      <select className="ql-color"></select>
      <select className="ql-background"></select>
    </span>
    <span className="ql-formats">
      {/* <button className="ql-blockquote"></button> */}
      {/* <button className="ql-code-block"></button> */}
      <button className="ql-link"></button>
    </span>
    <span className="ql-formats">
      <button className="ql-header" value="1"></button>
      <button className="ql-header" value="2"></button>
    </span>
    <span className="ql-formats">
      <button className="ql-list" value="ordered"></button>
      <button className="ql-list" value="bullet"></button>
      <button className="ql-indent" value="-1"></button>
      <button className="ql-indent" value="+1"></button>
    </span>
    <span className="ql-formats">
      <button className="ql-direction" value="rtl"></button>
      <select className="ql-align"></select>
    </span>
    <span className="ql-formats">
      <button className="ql-script" value="sub"></button>
      <button className="ql-script" value="super"></button>
    </span> 
  </div>
);

export default function ChatMessageForCopilot({
  message,
  parentRefreshClick,
  isLoading,
  displayMode,
  wordCount,
  charCount,
  handleDisplayModeChange,
  showCount,
  from,
  user_id,
  client_organization_id,
  grant_proposal_form_id,
  onRefreshPdf,
  docxData,
  setDocxData,
  convertToDocx,
  convertToPdf,
  selectedDocs
}) {

  const [messageRefreshed, setMessageRefreshed] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [tabList, setTabList] = useState([]);
  const [messageText, setMessageText] = useState(message.message);
  const messageRef = useRef(null);
  const [currentWordCount, setCurrentWordCount] = useState(0);
  const [currentCharCount, setCurrentCharCount] = useState(0);
  const [userMessageText, setUserMessageText] = useState(message.message);
  const [isUserEditing, setIsUserEditing] = useState(false);
  const [docnames,setDocNames]=useState('')
  console.log('Selected Docs',selectedDocs)
  // const convertMarkdownToHtml = (markdown) => {
  //   return DOMPurify.sanitize(marked(markdown));
  // };


const convertMarkdownToHtml = (markdown) => {
  if (!markdown) return '';
  
  const withStyledPDFs = markdown.replace(
    /(\/+)([^\s].*?)\.pdf\b/gi, 
    '<span style="color: magenta">📄 $2/</span>'
  );
  
  return DOMPurify.sanitize(marked(withStyledPDFs));
};

useEffect(() => {
  const docs = selectedDocs.join(" ");
  setDocNames(docs);
  console.log("xxx: " + docs);
}, [selectedDocs]);



//Refractor: can make it PDFHighlight
// const renderUserMessage = (text) => {
//   if (!text) return text;

//   // Split text into parts, separating PDF filenames
//   const parts = text.split(/(\b[\w\s()-]+\.pdf\b)/gi);

//   return parts.map((part, index) => {
//     // Check if the part is a PDF filename
//     if (part.toLowerCase().endsWith('.pdf')) {
//       return (
//         <span key={index} style={{ color: 'magenta' }}>
//           📄 {part.trim()} {/* File icon added here */}
//         </span>
//       );
//     }
//     // Return normal text for non-PDF parts
//     return <span key={index}>{part}</span>;
//   });
// };


  const baseurl = process.env.REACT_APP_API_URL; 
  useEffect(() => {
    const Font = ReactQuill.Quill.import("formats/font");
    Font.whitelist = fontClassNames;
    ReactQuill.Quill.register(Font, true);
  }, []);

  const modules = {
    toolbar: "#toolbar-container", 
  };

 const calculateWNS = (message) => {
  const text = (message || "").trim();
  const words = text ? text.split(/\s+/) : [];
  setCurrentWordCount(words.length);
  setCurrentCharCount(text.length);
};
  const handleContentInput = (e) => {
    calculateWNS(e.target.innerText);
  };

  const updateSelected = (selectedIdx) => {
    setTabList((prev) => {
      let newList = [...prev];
      let newObj = { selected: false };
      newList = newList.slice(selectedIdx, 1, newObj);
      return newList;
    });
  };

  
  const refreshClick = (e) => {
    parentRefreshClick();
    setMessageRefreshed(true);
    setTabList((prev) => {
      if (prev) {
        prev.map((elementInPrev) => {
          if (elementInPrev) {
            elementInPrev.selected = false;
          }
        });
        return [...prev, { selected: true }];
      }
    });
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };


  const handleSaveClick = async () => {
    const updatedDocxData = docxData.map((msg) =>
      msg.id === message.id ? { ...msg, message: messageText } : msg
    );

    setDocxData(updatedDocxData);
    onRefreshPdf(updatedDocxData);


    if (message.user === "bot") { 
      try {
        const response = await fetch(`${baseurl}/update-chat`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: user_id,
            client_id: client_organization_id,
            proposal_id: grant_proposal_form_id,
            message: messageText,
            question: message.question,
            timestamp: message.timestamp || new Date().toISOString(),
          }),
        });

        const data = await response.json();
        if (data.success) {
          
          setIsUserEditing(false);
          setIsEditing(false)
          // console.log(data.success, isEditing)
        }
      } catch (error) {
        console.error("Error updating message:", error);
      }
    }
  }; 

  const handleCancelClick = () => {
    setMessageText(message.message);
    setIsEditing(false);
  }; 

  //UseEffects
  useEffect(() => {
    if (messageRef.current && message.user === "bot") {
      messageRef.current.focus();
    }
  }, [message.user]);

  useEffect(() => {
    if (messageRef.current) {
      messageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [message.message]);

  useEffect(() => {
    calculateWNS(message.message);
  }, [message.message]);

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  const handleTextChange = (text) => {
    setMessageText(text); // Update the state when typing
  }; 
  
  return (
    <div
      className={`chat-message ${message.user === "bot" && "chatgpt w-full overscroll-contain scroll-smooth custom-scrollbar"
        } w-full`}
    >
      <div className="chat-message-center overscroll-contain w-full scroll-smooth custom-scrollbar">
        <div className="avatar-and-btns-div">
          {from != "copilot" && <>
            <div
              className={` ${message.user === "bot" &&
                "chatgpt editor-container"
                }`}
            >
              {/* Refractor: UserMessageEditor */}
              {message.user !== "bot" && (
                <UserMessageEditor
                  isUserEditing={isUserEditing}
                  userMessageText={userMessageText}
                  setUserMessageText={setUserMessageText}
                  handleEditClick={() => setIsUserEditing(true)}
                  handleSaveClick={() => setIsUserEditing(false)}
                  handleCancelClick={() => setIsUserEditing(false)}
                  message={message}
                  docnames={<PDFHighlight text={docnames} />}
                />
              )}

              {/* {message.user !== "bot" && ( 
                <>
                  {!isUserEditing ? (
                    <div className="text-left w-full text-sm whitespace-pre-wrap break-words">
                    <PDFHighlight text={docnames + " " + userMessageText} />
                  </div>
                  ) : (
                    <textarea
                      value={userMessageText}
                      onChange={(e) => {
                        setUserMessageText(e.target.value);
                        e.target.style.height = "auto"; // Reset height
                        e.target.style.height = `${e.target.scrollHeight}px`; // Set new height
                      }}
                      className="bg-[#380093] rounded-md border-2 border-[#1a0052] w-full p-2 resize-none overflow-y-auto"
                      cols={200} 
                      rows={12}
                    />
                  )}

                  <div className="message-controls  flex justify-start">
                    {!isUserEditing ? (
                      <button
                        className="edit-button text-green-500 underline px-1 py-1"
                        onClick={() => {
                          setIsUserEditing(true);
                          // handleEditClick(); // Call the handler function
                        }}
                      >
                        Edit
                      </button>
                    ) : (
                      <div className="edit-controls flex gap-2 mt-2">
                        <button
                          className="save-button text-green-500 underline px-4"
                          onClick={() => {
                            setIsUserEditing(false);
                            handleSaveClick(); // Call the save handler
                          }}
                        >
                          Save
                        </button>
                        <button
                          className="cancel-button text-red-500 underline px-4"
                          onClick={() => {
                            setUserMessageText(message.message);
                            setIsUserEditing(false);
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    )}
                  </div>
                </>
              )} */}
            </div> 
            {/* Refractor: WordCharCounter */}
            {message.user === "bot" && showCount && (
              <WordCharCounter
                displayMode={displayMode}
                wordCount={currentWordCount}
                charCount={currentCharCount}
                handleDisplayModeChange={handleDisplayModeChange}
              />
            )}
            {/* {message.user === "bot" && showCount && (
              <div className="word-char-count-container">
                <div className="flex flex-col gap-1 word-char-count-btn">
                  <button
                    className={`word-count ${
                      displayMode === "words" ? "bg-[#f272db] text-white" : "bg-[#2C0075] text-white opacity-70"
                    }`}
                    onClick={() => handleDisplayModeChange("words")}
                  >
                    w
                  </button>
                  <button
                    className={`character-count ${
                      displayMode === "characters" ? "bg-[#f272db] text-white" : "bg-[#2C0075] text-white opacity-70"
                    }`}
                    onClick={() => handleDisplayModeChange("characters")}
                  >
                    c
                  </button>
                </div>
                <div className="mt-1">
                  <span className="total-number-field">
                    {displayMode === "words"
                      ? currentWordCount
                      : currentCharCount }
                  </span>
                </div>
              </div>
            )} */}
          </>}
        </div>
        {/* Refractor: TabBar */}
        {message.user === "bot" && messageRefreshed && (
          <div className="tab-bar-div w-full">
            {tabList.map((tab, idx) => {
              if (tab) {
                return (
                  <div
                    onClick={() => updateSelected(idx)}
                    key={idx}
                    className={classNames("tab", tab.selected && "selected")}
                  />
                );
              }
            })}
          </div>
        )}
        <div>

          <div className="editor-container">
          {message.user === "bot" && (
            <BotMessageEditor
              isEditing={isEditing}
              messageText={messageText}
              convertMarkdownToHtml={convertMarkdownToHtml}
              handleTextChange={handleTextChange}
              handleEditClick={handleEditClick}
              handleSaveClick={handleSaveClick}
              handleCancelClick={handleCancelClick}
              modules={modules}
              CustomToolbar={CustomToolbar}
            />
          )}

            {/* {message.user === "bot" && (
              <> 
                <div className="quilljs-container">
                  {isEditing && <CustomToolbar />} 
                  <ReactQuill
                    key={isEditing ? "editing" : "reading"}
                    value={convertMarkdownToHtml(messageText)}
                    onChange={handleTextChange}
                    modules={isEditing ? modules : { toolbar: false }}
                    readOnly={!isEditing}
                    theme={isEditing ? "snow" : "bubble"} 
                  />
                </div>
                <div className="message-controls flex justify-start">
                  {!isEditing ? (
                    <button
                      className="edit-button text-green-500 underline px-4 py-1"
                      onClick={handleEditClick}
                    >
                      Edit
                    </button>
                  ) : (
                    <div className="edit-controls flex gap-2 mt-2">
                      <button
                        className="save-button text-green-500 underline px-4"
                        onClick={handleSaveClick}
                      >
                        Save
                      </button>
                      <button
                        className="cancel-button text-red-500 underline px-4"
                        onClick={handleCancelClick}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </div>
              </>
            )} */}
          </div>

        </div>
      </div>
    </div>
  );
};